import type { ReactNode } from "react";

/**
 * Brand marks for the two "Schau rein, hör rein." cards, in their official
 * colors — the only full-color elements on the black-and-white landing page.
 * Decorative: the card text carries the accessible name, so both are
 * `aria-hidden`.
 */

/** YouTube play button (white glyph on the red rounded rect). */
export function YouTubeMark(props: { readonly size?: number }): ReactNode {
  const size = props.size ?? 26;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <path
        fill="#FF0000"
        d="M23.5 6.9a3 3 0 0 0-2.11-2.12C19.5 4.27 12 4.27 12 4.27s-7.5 0-9.39.51A3 3 0 0 0 .5 6.9C0 8.8 0 12 0 12s0 3.2.5 5.1a3 3 0 0 0 2.11 2.12c1.89.51 9.39.51 9.39.51s7.5 0 9.39-.51a3 3 0 0 0 2.11-2.12C24 15.2 24 12 24 12s0-3.2-.5-5.1Z"
      />
      <path fill="#ffffff" d="M9.55 15.57 15.82 12 9.55 8.43Z" />
    </svg>
  );
}

/** Spotify mark (three white waves in the green circle). */
export function SpotifyMark(props: { readonly size?: number }): ReactNode {
  const size = props.size ?? 26;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <circle cx="12" cy="12" r="12" fill="#1DB954" />
      <g
        fill="none"
        stroke="#ffffff"
        strokeLinecap="round"
        strokeMiterlimit="10"
      >
        <path d="M5.5 9.5 Q12 6.3 18.5 9.5" strokeWidth="2.3" />
        <path d="M6.9 13.1 Q12 10.4 17.1 13.1" strokeWidth="2" />
        <path d="M8.2 16.4 Q12 14.2 15.8 16.4" strokeWidth="1.7" />
      </g>
    </svg>
  );
}
